import { render } from "./PropertiesIndex.vue?vue&type=template&id=3669a2f3"
import script from "./PropertiesIndex.vue?vue&type=script&lang=js"
export * from "./PropertiesIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/properties/PropertiesIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3669a2f3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3669a2f3', __exports__)) {
    api.reload('3669a2f3', __exports__)
  }
  
  module.hot.accept("./PropertiesIndex.vue?vue&type=template&id=3669a2f3", () => {
    api.rerender('3669a2f3', render)
  })

}


export default __exports__